import DeleteTierContainer from './DeleteTier.container';
import DeleteTier from './DeleteTier';
export default DeleteTierContainer(DeleteTier);
